import { render, staticRenderFns } from "./WindowsIcon.vue?vue&type=template&id=2e503d36&scoped=true"
import script from "./WindowsIcon.vue?vue&type=script&lang=js"
export * from "./WindowsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e503d36",
  null
  
)

export default component.exports